<app-nav></app-nav>
<section class="personalAccident-proposal-details">
  <form name="form" (ngSubmit)="f.form.valid" #personalForm="ngForm">  
    <div class="">
      <!-- Nav pills -->
      <ul class="nav nav-pills justify-content-center" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="pill" href="#details" [ngClass]="{ 'active':activeTab==='details'}" (click)="details('details')">Proposer's Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="pill" href="#questions" [ngClass]="{ 'active':activeTab==='questions'}" data-toggle="tab" (click)="questions('questions')">Questions</a>
        </li>
      </ul>
    
      <!-- Tab panes -->
      <div class="tab-content">
        
          <div id="details" class="container tab-pane active" [ngClass]="{ 'active':activeTab==='details'}"><br>
            <div class="row">
              <div class="col-2" style="padding-right:0px;">
                <p class="title mendatory">Title</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control"  name="title" [(ngModel)]="f.title"   id="title" #title="ngModel" style="padding:0px" required>
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                    </select>
                    <div *ngIf="title.invalid && title.touched " class="error-message">
                      <div *ngIf="title.errors.required">
                        Title is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">First Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="fName" [(ngModel)]="f.firstName" id="fName" #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                    <div *ngIf="fName.invalid && fName.touched " class="error-message">
                      <div *ngIf="fName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="fName.errors.pattern">
                        Please enter valid First name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">Last Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="lName" [(ngModel)]="f.lastName" id="lName" #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="lName.invalid && lName.touched " class="error-message">
                      <div *ngIf="lName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="lName.errors.pattern">
                        Please enter valid Last name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Mobile No.</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                    [(ngModel)]="f.mobile" #mobile1="ngModel" maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
                    <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                      <div *ngIf="mobile.errors.required">
                        Mobile number is required.
                      </div>
                      <div *ngIf="mobile.errors.maxlength">
                        Mobile number should not be greater than 10 digits.
                      </div>
                      <div *ngIf="mobile.errors.minlength">
                        Mobile number must be at least 10 digits long.
                      </div>
                      <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                        Invalid mobile number.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">E-mail Address</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="email" name="email" id="email" #email="ngModel" [(ngModel)]="f.email" [email]="true" maxlength="100" required>
                    <div *ngIf="email.invalid && email.touched " class="error-message">
                      <div *ngIf="email.errors.required">
                        Email Address is required.
                      </div>
                      <div *ngIf="email.errors.email">
                        Please enter correct Email address.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Branch of Medicine</p>
                <div class="form-group">
                    <select class="form-control long-text" id="medicineBranch" name="medicineBranch" [(ngModel)]="f.medicineBranch" #medicineBranch="ngModel" required>
                      <option>ALLOPATHY</option>
                      <option>AYURVEDA</option>
                      <option>HOMEPATHY</option>
                      <option>ANY OTHER</option>
                    </select>
                    <div *ngIf="medicineBranch.invalid && medicineBranch.touched " class="error-message">
                      <div *ngIf="medicineBranch.errors.required">
                        Please select Medicine Branch.
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <!-- Uncomment this for append lines -->
            <!-- <button (click)="addQual()">+</button>
            <div class="row" *ngFor="let qual of qualification; let i = index;">
              <div class="col-8">
                <p class="title mendatory">All Professional Qualification {{i+1}}</p>
                <div class="form-group">
                  <input class="form-control" type="text" name="qualification_{{i+1}}" [(ngModel)]="f.qualification_{{i+1}}" id="qualification_{{i+1}}" #qualification="ngModel" maxlength="200" required>
                  <div *ngIf="qualification.invalid && qualification.touched " class="error-message">
                    <div *ngIf="qualification.errors.required">
                      Professional Qualification is required.
                    </div>
                  </div>
              </div>
            </div> -->
            <!-- Uncomment this for append lines -->
            <div class="row">
              <div class="col-8">
                <p class="title mendatory">All Professional Qualification</p>
                <div class="form-group">
                  <input class="form-control" type="text" name="qualification" [(ngModel)]="f.qualification" id="qualification" #qualification="ngModel" maxlength="200" required>
                  <div *ngIf="qualification.invalid && qualification.touched " class="error-message">
                    <div *ngIf="qualification.errors.required">
                      Professional Qualification is required.
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-4">
              <p class="title mendatory">Year</p>
              <div class="form-group">
                  <input class="form-control" type="text" name="year" [(ngModel)]="f.year" id="year" #year="ngModel" maxlength="4" minlength="4" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,4}\d*)$" inputmode="numeric" required>
                  <div *ngIf="year.invalid && year.touched " class="error-message">
                    <div *ngIf="year.errors.required">
                      Year of qualification is required.
                    </div>
                    <div *ngIf="year.errors.maxlength">
                      Year is too long.
                    </div>
                    <div *ngIf="year.errors.minlength && !year.errors.pattern">
                      Please enter complete year.
                    </div>
                    <div *ngIf="(!year.errors.minlength || year.errors.pattern) && !year.errors.required">
                      Invalid year entered.
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="title mendatory">Year of Registration</p>
              <div class="form-group">
                  <input class="form-control" type="text" name="yearOfReg" [(ngModel)]="f.yearOfReg" id="yearOfReg" #yearOfReg="ngModel" (keydown.space)="$event.preventDefault();" inputmode="numeric" required>
                  <div *ngIf="yearOfReg.invalid && yearOfReg.touched " class="error-message">
                    <div *ngIf="yearOfReg.errors.required">
                      Year of Registration is required.
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-6">
              <p class="title mendatory">Medical Registration No.</p>
              <div class="form-group">
                <input class="form-control" type="text" name="medicalReg" [(ngModel)]="f.medicalReg" id="medicalReg" #medicalReg="ngModel" maxlength="200" required>
                <div *ngIf="medicalReg.invalid && medicalReg.touched " class="error-message">
                  <div *ngIf="medicalReg.errors.required">
                    Medical Registration number is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Average no. of patient you attended per day</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="avgPatient" [(ngModel)]="f.avgPatient" id="avgPatient" #avgPatient="ngModel" (keydown.space)="$event.preventDefault();" inputmode="numeric" required>
                  <div *ngIf="avgPatient.invalid && avgPatient.touched " class="error-message">
                    <div *ngIf="avgPatient.errors.required">
                      Please enter Average no. patient.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="title mendatory">Year of Practice</p>
              <div class="form-group">
                <input class="form-control" type="text" name="practiceYear" [(ngModel)]="f.practiceYear" id="practiceYear" #practiceYear="ngModel" (keydown.space)="$event.preventDefault();" inputmode="numeric" required>
                <div *ngIf="practiceYear.invalid && practiceYear.touched " class="error-message">
                  <div *ngIf="practiceYear.errors.required">
                    Year of practice is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <p class="title mendatory">Limit of Indemnity</p>
              <div class="form-group">
                <input class="form-control" type="text" name="sumInsured" [(ngModel)]="f.sumInsured" id="sumInsured" #sumInsured="ngModel" maxlength="200" required disabled>
                <!-- <div *ngIf="sumInsured.invalid && sumInsured.touched " class="error-message">
                  <div *ngIf="sumInsured.errors.required">
                    Limit of Indemnity is required.
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Specialization</p>
              <div class="sum-insured-input">
                <div class="form-group">
                <input class="form-control" type="text" name="specialization" [(ngModel)]="f.selectedSpecialization" id="specialization" #selectedSpecialization="ngModel" maxlength="200" required disabled>                    
                    <!-- <div *ngIf="specialization.invalid && specialization.touched " class="error-message">
                      <div *ngIf="specialization.errors.required">
                        Please select Specialization.
                      </div>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              <p class="title mendatory">Policy Start Date</p>
              <div class="sum-insured-input reg-date-input proposal-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="policyStartDate" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2020:2200" placeholder="Date" name="policyStartDate" [minDate]="startDate" (onSelect)="setPolicyEndDate()"  keepInvalid [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="shouldBe18" class="error-message">
                  Date of birth should be greater than 18.
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Date of Birth is required.
                </div>
              </div>
            </div>
            <div class="col-6">
              <p class="title mendatory">Policy End Date</p>
              <div class="sum-insured-input reg-date-input proposal-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="policyEndDate" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" placeholder="Date" name="policyEndDate" [maxDate]="value" keepInvalid [required]="true" disabled="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="shouldBe18" class="error-message">
                  Date of birth should be greater than 18.
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Date of Birth is required.
                </div>
              </div>
            </div>
          </div>
              
              
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Address</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <textarea class="form-control" type="text" name="address1" [(ngModel)]="f.address1" id="address1" #address1="ngModel" maxlength="500" required></textarea>
                  <div *ngIf="address1.invalid && address1.touched " class="error-message">
                    <div *ngIf="address1.errors.required">
                      Address is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveOrSubmitProposalPage('save');">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue" (click)="details('questions')">Next</button>
            </div>
            <!-- <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" (click)="openModal(template);getProposalService(f);" [disabled]="personalForm.form.invalid" id="proceedPayment">Proceed</button>
              </div> -->
          </div>
        </div>
        <div id="questions" class="container tab-pane questions-section" [ngClass]="{ 'active':activeTab==='questions'}"><br>
          <div class="row">
            <div class="col">
              <span class="dot"></span><span class="title">Are you a member of any Medical Association/ Council?</span>
              <input type="radio" name="member" [(ngModel)]="f.member" ><span class="mr80 ml-2">No</span>
              <input type="radio" name="member" [(ngModel)]="f.member" [value]="true" [checked]="f.member"><span class="ml-2">Yes</span>
            </div>
          </div>
          <div class="row" *ngIf="f.member">
            <div class="col mt-3">
              <p>Details of Associations/Counsil</p>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Name" type="text" name="AssoName" [(ngModel)]="f.AssoName" id="AssoName" #AssoName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                <div *ngIf="AssoName.invalid && AssoName.touched " class="error-message">
                  <div *ngIf="AssoName.errors.required">
                    Name is required.
                  </div>
                  <div *ngIf="AssoName.errors.pattern">
                    Please enter valid Name.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <input type="text" name="AssoConact" id="AssoConact" class="form-control" placeholder="Contact No."
                [(ngModel)]="f.AssoConact" #AssoConact="ngModel" maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
                <div *ngIf="AssoConact.invalid && AssoConact.touched " class="error-message">
                  <div *ngIf="AssoConact.errors.required">
                    Contact number is required.
                  </div>
                  <div *ngIf="AssoConact.errors.maxlength">
                    Contact number should not be greater than 10 digits.
                  </div>
                  <div *ngIf="AssoConact.errors.minlength">
                    Contact number must be at least 10 digits long.
                  </div>
                  <div *ngIf="(!AssoConact.errors.minlength || AssoConact.errors.pattern) && !AssoConact.errors.required">
                    Invalid contact number.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <textarea class="form-control" type="text" placeholder="Address" name="assoAddress" [(ngModel)]="f.assoAddress" id="assoAddress" #assoAddress="ngModel" maxlength="500" required></textarea>
                <div *ngIf="assoAddress.invalid && assoAddress.touched " class="error-message">
                  <div *ngIf="assoAddress.errors.required">
                    Address is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <span class="dot"></span><span class="title">Are you attached to/or attending a visiting physician/surgeon in any Hospital/Nursing Home/Clinic etc.?</span>
              <input type="radio" name="attached" [(ngModel)]="attached"><span class="mr80 ml-2">No</span>
              <input type="radio" name="attached" [(ngModel)]="attached" value="true" [checked]="attached"><span class="ml-2">Yes</span>
            </div>
          </div>
          <div class="row" *ngIf="attached">
            <div class="col mt-3">
              <div class="form-group">
                  <textarea class="form-control" type="text" name="attachDetails" placeholder="Please give details" [(ngModel)]="f.attachDetails" id="attachDetails" #attachDetails="ngModel" maxlength="500" required></textarea>
                  <div *ngIf="attachDetails.invalid && attachDetails.touched " class="error-message">
                    <div *ngIf="attachDetails.errors.required">
                      Details are required.
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <span class="dot"></span><span class="title">Does the proposer currently hold any Professional Indemnity Insurance?</span>
              <input type="radio" name="hold" [(ngModel)]="hold"><span class="mr80 ml-2">No</span>
              <input type="radio" name="hold" [(ngModel)]="hold" [value]="true" [checked]="hold"><span class="ml-2">Yes</span>
            </div>
          </div>
          <div class="row" *ngIf="hold">
            <div class="col-12 mt-3">
              <p>Attach last year policy copy</p>
              <div class="sum-insured-input">
                  <div class="form-group">
    
                    <input id="addAttachment" style="display: none" type="file" (change)="onFileChanged($event)" #fileInput
                      ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx" [uploader]="uploader" multiple required="true">
                    <img class="attachment-icon" (click)="fileInput.click()">
                    <label>Attach Files</label>
                    <div class="mt-2">
                      <div class="" *ngIf="uploading">
                        <span class="spinner-border spinner-border-sm text-info"></span>
                        Uploading..
                      </div>
                      <div class="attachmentList" *ngFor='let name of fileNameArray'>
                        <li>{{name}} <button class="btnDeleteFile" (click)="removeSelectedFile(index)"></button></li>
                      </div>
                      <!-- <div class="col" *ngFor='let url of urls'>
                        <img  [src]="url" height="20">
                      </div> -->
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-12">
              <p>Retroactive date as per previous policy</p>
              <div class="sum-insured-input reg-date-input proposal-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="f.retroactiveDate" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" placeholder="Date" name="retroactiveDate"  keepInvalid [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="retroactiveDateRequired" class="error-message">
                    Retroactive Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <span class="dot"></span><span class="title">Have any claims been made upon you or legal proceeding instituted or likely to be instituted against you by patients in respect of your treatment etc.?</span>
              <input type="radio" name="claims" [(ngModel)]="claims"><span class="mr80 ml-2">No</span>
              <input type="radio" name="claims" [(ngModel)]="claims" [value]="true" [checked]="claims"><span class="ml-2">Yes</span>
            </div>
          </div>
          <div class="row" *ngIf="claims">
            <div class="col mt-3">
              <div class="form-group">
                  <textarea class="form-control" type="text" name="claimsDetails" placeholder="Please give details" [(ngModel)]="f.claimsDetails" id="claimsDetails" #claimsDetails="ngModel" maxlength="500" required></textarea>
                  <div *ngIf="claimsDetails.invalid && claimsDetails.touched " class="error-message">
                    <div *ngIf="claimsDetails.errors.required">
                      Details are required.
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveOrSubmitProposalPage('save');">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue" (click)="openModal(template);" [disabled]="personalForm.form.invalid">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #template>
      <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body">
        <div class="col">
          <h4 class="modal-title">Terms & Conditions</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
              <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col mt-4">
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck" #termCheck="ngModel" required> I/We do hereby declare that the above statements and answers are true and what I/We have not withheld any information whatsoever regarding the proposal.
              I/We hereby declare that all statutory provisions relating to my/our business proposed for insurance are complied with. I/We agree that this proposal and declarations shall be the basis of the contract between me/us and United India Whose policy for the insurance proposed is acceptable to me/us. I/We undertake to exercise all ordinary and reasonable precautions for safety of the property as if it were uninsured.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2" #termCheck2="ngModel" required> I/we hereby authorize SecureNow to act our exclusive insurance broker for placing our Professional Indemnity Policy.</label>
          </div>
        </div>
  
        <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close" (click)="modalRef.hide();saveOrSubmitProposalPage('submit');" [disabled]="f.form.invalid">Ok</button>
        </div>
      </div>
      </form>
    </ng-template>
    <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
    </div>
    <span id="snackbar"></span>
  </form>
</section>